export default __webpack_public_path__ + "static/media/wallex_updated.db2fbe33.svg";